import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';

const navItems = [
  { name: 'Home', path: '/' },
  { name: 'Events', path: '/events' },
  { name: 'Gallery', path: '/gallery' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="w-full bg-white shadow sticky top-0 z-50">
      <nav className="max-w-none w-full px-2 sm:px-4 md:px-12 xl:px-32 flex items-center justify-between h-16">
        <Link to="/" className="font-bold text-lg text-primary tracking-wide">Inder Events And Production</Link>
        <div className="hidden sm:flex gap-2 md:gap-4">
          {navItems.map(item => (
            <Link
              key={item.name}
              to={item.path}
              className={`px-3 py-2 rounded font-medium transition ${location.pathname === item.path ? 'text-primary font-bold bg-primary/10' : 'text-gray-800 hover:bg-primary/10'}`}
            >
              {item.name}
            </Link>
          ))}
        </div>
        <button className="sm:hidden p-2" onClick={() => setMobileOpen(true)}>
          <Menu className="w-6 h-6 text-primary" />
        </button>
      </nav>
      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 bg-black/40 flex justify-end" onClick={() => setMobileOpen(false)}>
          <div className="bg-white w-64 h-full p-6 flex flex-col gap-4" onClick={e => e.stopPropagation()}>
            <div className="font-bold text-lg text-primary mb-4">Inder Events And Production</div>
            {navItems.map(item => (
              <Link
                key={item.name}
                to={item.path}
                className={`block px-3 py-2 rounded font-medium transition ${location.pathname === item.path ? 'text-primary font-bold bg-primary/10' : 'text-gray-800 hover:bg-primary/10'}`}
                onClick={() => setMobileOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
